import Cookies from 'js-cookie';
import { Api } from './request';

const TokenKey = 'mb_mg_token';

export const getPayload = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    throw new Error('parse token failed: ' + e.message);
  }
};

export const getToken = () => {
  const now = Date.now();
  const token: any = Cookies.get(TokenKey);
  if (!token || !token.length) {
    return undefined;
  }
  const { exp } = getPayload(token.toString());
  // token invalid
  if (now - exp * 1000 > 0) {
    return undefined;
  }
  return token;
};

export const setToken = (token: string) => Cookies.set(TokenKey, token);

export const removeToken = () => Cookies.remove(TokenKey);

export const getCacheUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo') || '{}');
};

export const getUserInfo = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('token Invaild');
  }
  const userInfo = await Api.Users.get();
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  return userInfo;
};

export const getOpenId = () => {
  const { openId } = getCacheUserInfo();
  return openId;
};

export const getUserId = () => {
  const { id } = getCacheUserInfo();
  return id;
};

export const login = async (code: string) => {
  const token = await Api.Users.mpLogin({ code });
  setToken((token as any).toString());
  const userInfo = await getUserInfo();
  return userInfo;
};

export const getStore = () => {
  return JSON.parse(localStorage.getItem('currentStore') || '{}');
};

export const setStore = (store: any) => {
  localStorage.setItem('currentStore', JSON.stringify(store));
  return JSON.parse(localStorage.getItem('currentStore') || '{}');
};
